"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarNotificationPopoverFooter = void 0;
const react_1 = __importStar(require("react"));
const AppBarNotificationPopoverFooter_styles_1 = require("./AppBarNotificationPopoverFooter.styles");
const Button_1 = require("../../../../../../../Button");
const Icon_1 = require("../../../../../../../Icon");
const icons_1 = require("../../../../../../../icons");
const StackView_1 = require("../../../../../../../StackView");
const Text_1 = require("../../../../../../../Text");
const Toggle_1 = require("../../../../../../../Toggle");
const View_1 = require("../../../../../../../View");
exports.AppBarNotificationPopoverFooter = react_1.default.memo(({ showClearAll, onClearAllClick, clearAllText, noAutoDisplay, autoDisplayText, isAutoDisplay, onAutoDisplayChange, isClearAllDisabled }) => {
    const distribution = (0, react_1.useMemo)(() => (showClearAll ? StackView_1.STACK_DISTRIBUTION.between : StackView_1.STACK_DISTRIBUTION.end), [showClearAll]);
    return (react_1.default.createElement(AppBarNotificationPopoverFooter_styles_1.StyledAppBarNotificationPopoverFooter, null,
        react_1.default.createElement(StackView_1.StackView, { borderTop: View_1.VIEW_BORDER.normal, align: StackView_1.STACK_ALIGN.center, distribution: distribution, spaceVertical: View_1.INDENT.s, spaceHorizontal: View_1.INDENT.m, gap: StackView_1.STACK_GAP.m },
            showClearAll && (react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.end },
                react_1.default.createElement(Button_1.Button, { "data-selector-id": "notification-clear-all", disabled: isClearAllDisabled, ui: Button_1.BUTTON_VIEW.text, onClick: onClearAllClick },
                    react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.ClearAllIcon, null) }),
                    clearAllText))),
            !noAutoDisplay && (react_1.default.createElement(StackView_1.StackView, { testId: "auto-display-controller-container", gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.end },
                react_1.default.createElement(Text_1.Text, null, autoDisplayText),
                react_1.default.createElement(Toggle_1.Toggle, { value: isAutoDisplay, onChange: onAutoDisplayChange }))))));
});
exports.AppBarNotificationPopoverFooter.displayName = 'AppBarNotificationPopoverFooter';
//# sourceMappingURL=AppBarNotificationPopoverFooter.js.map